import React, { useReducer, createContext } from "react";
import { jwtDecode } from "jwt-decode";
import { NavLink, useNavigate } from "react-router-dom";

const initialState = {
  user: null
}

if (localStorage.getItem("jwtToken")) {
  const decodedToken = jwtDecode(localStorage.getItem("jwtToken"));

  localStorage.setItem('permission', decodedToken.permission);

  if (decodedToken.exp*1000 < Date.now()) {
    localStorage.removeItem("jwtToken");
    // localStorage.removeItem('permission');
  } else {
    initialState.user = decodedToken;
  }
}

const AuthContext = createContext({
  user: null,
  login: userData => {},
  logout: () => {}
});

function authReducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: action.payload
      };
    case "LOGOUT":
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const navigate = useNavigate();
  
  function login(userData) {
    localStorage.setItem("jwtToken", userData.token);
    localStorage.setItem("permission", userData.permission);
    dispatch({
      type: "LOGIN",
      payload: userData
    });
  }

  function logout() {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem('permission');
    dispatch({
      type: "LOGOUT"
    });
    navigate("/login")
    window.location.reload();
  }

  return (
    <AuthContext.Provider
      value={{ user: state.user, login, logout }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider }
